<template>
    <div>
        <slot></slot>

        <portal :to="portalTo ? portalTo : name" :disabled="!portalErrors">
            <div v-show="displayErrors && uniqueErrors.length > 0" class="tw-mt-1">
                <p v-for="(message, index) in uniqueErrors" class="tw-text-red-500 tw-text-sm tw-font-bold tw-whitespace-pre-line" :key="index">{{ message }}</p>
            </div>
        </portal>
        
        <p v-if="note" class="help-block tw-mb-0" style="white-space: pre-line">{{ note }}</p>
    </div>
</template>

<script>
export default {
    name: "FormControl",

    props: {
        name: {
            type: String,
            default: null
        },
        initial: {
            default: null
        },
        note: {
            default: null
        },
        errors: {
            type: Array,
            default: function() {
                return []
            }
        },
        portalErrors: {
            type: Boolean,
            default: false
        },
        portalTo: {
            type: String,
            default: null
        },
        disableStyling: {
            type: Boolean,
            default: false
        },
        additionalErrors: {
            type: Array,
            default: function() {
                return []
            }
        }
    },

    data() {
        return {
            controls: [],
            errorStore: this.errors,
            displayErrors: false,
            parent: null
        }
    },

    computed: {
        uniqueErrors() {
            return [...new Set(this.errorStore)]
        },

        receiveErrorsFor() {
            let errors = this.additionalErrors;
            errors.push(new RegExp('^' + this.name + '$'));

            return errors;
        }
    },

    created() {
        if(this.name) {
            this.register(this);
        }
    },

    mounted() {
        // Grab any form controls
        this.controls = this.$el.querySelectorAll('[name]');
        
        // Regular form inputs should have a form-control class
        let regex = new RegExp('checkbox|radio|file|hidden')

        this.controls.forEach(control => {
            if(!regex.test(control.type)) {
                if(!this.disableStyling) {
                    control.classList.add('form-control');
                }

                control.setAttribute('spellcheck', 'false');
            }
        });
    
        if(this.initial != null && typeof this.initial == 'object') {
            // If the control's value is stored as an array, append [] to the name so php can parse it as an array 
            for(let control of this.controls) {
                control.name += '[]';
            }
        }

        // If there are any errors passed in right away, display them
        if(this.errorStore.length > 0) {
            this.$nextTick(() => {
                this.toggleErrors(true);
            });
        }

        // The parent should listen for an input event on any form inputs in the slot, and hide the error
        this.$el.addEventListener('input', event => { 
            if(this.name) {
                this.parent.$emit('clear-error', this.name);
                // this.toggleErrors(false);
            }
        });

        this.$children.forEach(child => {
            child.$on('clear-error', name => {
                this.parent.$emit('clear-error', name);
            });
        });
    },

    methods: {
        register(component) { 
            let parent = component.$parent;
            if(parent.$options._componentTag == "base-form") {
                this.parent = parent;
                parent.$set(parent.controls, this.name, this);

                if(this.initial != null && !parent.state.hasOwnProperty(this.name)) {
                    parent.$set(parent.state, this.name, this.initial);
                    parent.$set(parent.initialState, this.name, this.initial);
                }
            } else {
                this.register(parent);
            }
        },

        toggleErrors(value) {
            this.displayErrors = value;

            this.controls.forEach(control => {
                control.classList.toggle('tw-border-red-500', value);
            });

            // Some child components may require special logic to display as having an error
            // Dispatch an event to any child components so they can handle error styling locally
            for(let child of this.$children) {
                child.$emit('error', value);
            }
        },

        setErrors(errors) {
            this.errorStore = errors;
            this.toggleErrors(errors.length > 0);
        }
    }
}
</script>

<style>

</style>